import { create } from 'zustand';
const resultValues={
open:false
}
const useSuccessModelStore = create((set) => ({
  successModalData: { ...resultValues },
  setSuccessModalData: (newFormData) => 
    set((state) => ({
      successModalData: { ...state.previewData, ...newFormData },
    })),
}));

export default useSuccessModelStore;
